import { Component, ElementRef, OnInit, Renderer2, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { EmailTemplateDataService } from 'src/app/services/email-template-data.service';
import { PreviousUrlService } from 'src/app/services/previous-url.service';
import { SideNavBarVisibilityService } from 'src/app/services/side-nav-bar-visibility.service';
import { ZpDataService } from 'src/app/services/zp-data.service';
import { ThemeService } from 'src/app/theme/theme-service.service';


@Component({
    selector: 'app-email-template',
    templateUrl: './email-template.component.html',
    styleUrls: ['./email-template.component.scss'],
    standalone: false
})
export class EmailTemplateComponent implements OnInit {
  @ViewChild('textarea') textarea: ElementRef<HTMLTextAreaElement>;
  @ViewChild('inputText') inputText: ElementRef<HTMLInputElement>;

  public activeTheme: any;
  public emailTemplate: any;
  public emailTemplateBody: any;
  public emailTemplateSubject: any;
  public inputEmailBody: string;
  public inputEmailSubject: string;
  public emailInfoToSave: { 
    mailSubject: string; 
    mailBody: string; 
    userList: any[], 
    reminder?: string, 
    firstName?: string, 
    lastName?: string, 
    email?: string 
  };
  public retrievedData: any;
  public previousLink: string;
  public displayRetrievedData: boolean = false;
  public insertFieldValues: any;
  public defaultOption: string = 'Insert Field';
  public editableTemplateBody: string;
  public retrievedEditableTemplateBody: string;
  public reminders = [
    { label: 'No Reminder', value: 'No Reminder' },
    { label: '1 day', value: '1 day' },
    { label: '7 days', value: '7 days' },
    { label: '14 days', value: '14 days' },
    { label: '30 days', value: '30 days' }
  ];
  public defaultReminder = '1 day';
  public input1HtmlDetected: boolean = false;
  public input2HtmlDetected: boolean = false;
  selectedReminder: string;

  constructor(
    public themeService: ThemeService,
    public sideNavBarVisibilityService: SideNavBarVisibilityService,
    private router: Router,
    private api: ZpDataService,
    private emailTemplateDataService: EmailTemplateDataService,
    private previousUrl: PreviousUrlService,
    private renderer: Renderer2, 
    private el: ElementRef) { }

  async ngOnInit() {
    this.selectedReminder = this.defaultReminder;
    this.activeTheme = this.themeService.active;
    this.previousLink = this.previousUrl.getPreviousUrl();
    this.retrievedData = await this.emailTemplateDataService.getData();
    this.insertFieldValues = await this.api.getProfessionalInviteTemplatePlaceholders();
    console.log('retrievedData: ', this.retrievedData);

    if (this.emailTemplate = await this.api.getProfessionalInviteTemplate()) {
      console.log('emailTemplate: ', this.emailTemplate)
      this.emailTemplateSubject = this.emailTemplate.mail_template.subject;
      this.emailTemplateBody = this.emailTemplate.mail_template.body;
      this.editableTemplateBody = this.extractContentFromBody(this.emailTemplate.mail_template.body);
    }
    if (this.previousLink == "/email-preview") {
      this.displayRetrievedData = true;
      this.retrievedEditableTemplateBody = this.extractContentFromBody(this.retrievedData.data.mailBody);
      this.emailInfoToSave = {
        mailSubject: this.retrievedData.data.mailSubject,
        mailBody: this.retrievedData.data.mailBody,
        userList: this.retrievedData.data.userList
      }
    }
    if (this.previousLink != "/email-preview") {
      this.emailInfoToSave = {
        mailSubject: this.emailTemplateSubject,
        mailBody: this.emailTemplateBody,
        userList: this.retrievedData.data,
        reminder: this.defaultReminder
      }
    }
    if (this.previousLink == "/invite-only") {
      this.emailInfoToSave = {
        mailSubject: this.emailTemplateSubject,
        mailBody: this.emailTemplateBody,
        userList: [
          {
            firstName: this.retrievedData.data.firstName,
            lastName: this.retrievedData.data.lastName,
            email: this.retrievedData.data.email,
          }
        ],
        reminder: this.defaultReminder
      }
    }
  }

  onHtmlDetected(inputNumber: number, detected: boolean) {
    if (inputNumber === 1) {
      this.input1HtmlDetected = detected;
    } else if (inputNumber === 2) {
      this.input2HtmlDetected = detected;
    } 
  }

  extractContentFromBody(htmlString) {
    let bodyContentRegex = /<div id="body">(.*?)<\/div>/s;
    let match = bodyContentRegex.exec(htmlString);
    if (match) {
      let divContent = match[1]
      return divContent.replace(/<br>/gi, '\n');
    }
  }

  insertContentIntoBody(str: string, htmlString: string) {
    let html = str.replace(/\n/gi, '<br>');
    let updatedHtmlString = htmlString.replace(/(<div id="body">).*?(<\/div>)/s, `$1${html}$2`);
    return updatedHtmlString;
  }

  inputChangeEmail(event: any, element: string) {
    if (element === 'input') {
      this.inputEmailSubject = event.target.value;
      this.emailInfoToSave.mailSubject = this.inputEmailSubject;
    }
  }

  insertText(selectedValue: string) {
    const disabledValues = ['Professional Referral Code', 'Professional Referral Link'];
    const textToInsert = `${selectedValue}`;
    const cursorPosition = this.textarea.nativeElement.selectionStart;
    const textBeforeCursor = this.textarea.nativeElement.value.substring(0, cursorPosition);
    const textAfterCursor = this.textarea.nativeElement.value.substring(cursorPosition);
    const newValue = textBeforeCursor + textToInsert + textAfterCursor;
    this.textarea.nativeElement.value = newValue;
    if (disabledValues.includes(selectedValue)) {
      setTimeout(() => {
        this.disableInsertedValue(selectedValue);
      }, 0);
    }
  }

  disableInsertedValue(selectedValue: string) {
    const textareaValue = this.textarea.nativeElement.value;
    const disabledStartTag = `<disabled>[`;
    const disabledEndTag = `]</disabled>`;

    const startIndex = textareaValue.indexOf(`[${selectedValue}]`);
    if (startIndex !== -1) {
      const endIndex = startIndex + selectedValue.length + 2;
      const disabledValue = disabledStartTag + selectedValue + disabledEndTag;
      this.textarea.nativeElement.value =
        textareaValue.substring(0, startIndex) +
        disabledValue +
        textareaValue.substring(endIndex);
    }
  }

  onReminderSelected(selectedValue: string) {
    // if (this.emailInfoToSave.userList.length > 0) {
    //   this.emailInfoToSave.userList[0].reminder = selectedValue;
    // }
    this.selectedReminder = selectedValue;
    this.emailInfoToSave.reminder = this.selectedReminder;
    console.log('this.emailInfoToSave ', this.emailInfoToSave);
  }

  goToEmailPreview() {
    let textareaValue = this.textarea.nativeElement.value;
    if (this.previousLink == '/email-preview') {
      this.emailInfoToSave.mailBody = this.insertContentIntoBody(textareaValue, this.emailTemplateBody);
    } else {
      this.emailInfoToSave.mailBody = this.insertContentIntoBody(textareaValue, this.emailTemplateBody);
    }
    this.saveData();
    this.router.navigate(['/email-preview']);
  }

  saveData() {
    console.log('this.emailInfoToSave ', this.emailInfoToSave);
    this.emailTemplateDataService.setData(this.emailInfoToSave, this.insertFieldValues);
  }
}